import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { CmsServiceService } from '../../services/cms_services/cms-service.service';
import { HttpClient, HttpParams } from '@angular/common/http';
import { StmgService } from '../../services/state_Management/stmg.service';
import { newsCat_pObj } from '../../services/payload/newsCat_pobj';
import { CommonServiceService } from '../../services/common_service/common-service.service';

@Component({
  selector: 'app-news-info',
  templateUrl: './news-info.component.html',
  styleUrls: ['./news-info.component.scss'],
})

export class NewsInfoComponent implements OnInit {

  categoryList: any = [];
  listSet: any = [];
  listSetImg: any = [];

  constructor(public modalCtrl: ModalController,
    public translate: TranslateService,
    private cmsServiceService: CmsServiceService,
    private http: HttpClient,
    private stmgService: StmgService,
    private commonservice: CommonServiceService,
  ) {
    //translate.use('en');
  }

  ngOnInit() {
    this.stmgService.newsCategoriesObservable.subscribe(newsCategories =>
      this.setData(newsCategories)
    )
  }

  setData(newsCategoriesSet) {
    let tempData = newsCategoriesSet;
    //console.log("news Categories", tempData)

    for (var key in tempData) {
      if (key != "status") {
        this.categoryList.push(tempData[key])
      }
    }
    this.setCategoryUrl();
  }

  setCategoryUrl() {
    for (let i = 0; i < this.categoryList.length; i++) {
      this.listSet[i] = {
        term_thumbnail: JSON.parse(this.categoryList[i].term_thumbnail),
        name: this.categoryList[i].name,
        term_id: this.categoryList[i].term_id
      };
    }
    //console.log("list set:::", this.listSet)
  }

  selectedCategory(category) {
    this.stmgService.updateSelectedCategory(category)
    this.dismiss()
  }

  dismiss() {
    this.modalCtrl.dismiss({
      'dismissed': true
    });
  }

}
